import React, { useEffect, useState } from 'react'
import Loader from '../../loader/Loader';
import { Form, Table } from 'react-bootstrap';
import { GetEmployeeReportsFilesDto, GetFilesByUploaderAndUserResponse, PaginationDto } from '../../../../interfaces/Employee/Employee';
import { GetEmployeeReportsFiles } from '../../../../services/EmployeeService/EmployeeService';
import { useAuth } from '../../../../firebase/AuthProvider';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { TABLENAMES } from '../../../../Data/SD';
import tableeyeopenicon from "../../../../assets/images/tableeyeopenicon.svg";
import Pagination from '../../../ui/Pagination/Pagination';

const EmployeeReportTab = () => {
    const { currentUser } = useAuth();
    const { userId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [employeeReports, setEmployeeReports] = useState<GetFilesByUploaderAndUserResponse>();
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });


    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                getEmployeeFiles(token, pagination.pageNumber, pagination.pageSize);
            }
        })
    }, [pagination]);

    const getEmployeeFiles = (token: string, pageNumber: number = 1, pageSize: number = 10) => {
        if (!userId) return;
        setLoading(true);
        GetEmployeeReportsFiles(token, userId, pageNumber, pageSize).then((response) => {
            if (response.success) {
                setEmployeeReports(response.data);
            } else {
                toast.error(response.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const NaviagateToViewFile = async (fileId: any) => {
        navigate(`/view/file/${fileId}/${TABLENAMES.EMPLOYEE_FILE}`);
    };

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }
    return (
        <>
            {loading && <Loader />}
            <div className='common_content_inner mby_t_24'>
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Uploaded Date</th>
                            <th className='action_th'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employeeReports?.employeeFiles.length === 0 ?
                            (
                                <tr>
                                    <td colSpan={3}>
                                        <p className='text-center'>{loading ? 'Loading...' : 'No Report Found'}</p>
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {employeeReports?.employeeFiles.map((item, index) => (
                                        <tr className="border-t border-gray-200 dark:border-gray-700 text-sm hover:bg-gray-50 dark:hover:bg-gray-800">
                                            <td className='file-name'>{item.fileName}</td>
                                            <td className='file-date'>{moment(item.dateAdded).format('DD/MM/YYYY')}</td>
                                            <td className="action_btn">
                                                <button onClick={() => { NaviagateToViewFile(item.id); }}>
                                                    <img src={tableeyeopenicon} alt="tableeyeopenicon" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                    }

                                </>

                            )}

                    </tbody>
                </Table>
                {employeeReports && employeeReports.count > 0 && (
                    <Pagination
                        currentPage={pagination.pageNumber}
                        totalPages={Math.ceil(employeeReports.count / pagination.pageSize)}
                        onPageChange={onPageChange}
                        pageSize={pagination.pageSize}
                        resetPageSize={resetPageSize}
                    />
                )}

            </div>
        </>
    )
}

export default EmployeeReportTab